import Vue from "vue";
import Router from "vue-router";
import AuthGuard from "./auth-guard";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      meta: { offlineAvailability: true, fullscreen: true },
      component: () =>
        import(/* webpackChunkName: "login" */ "../views/Login.vue"),
    },
    {
      beforeEnter: AuthGuard,
      path: "/questionnaire",
      name: "questionnaire",
      meta: { offlineAvailability: true, fullscreen: true },
      component: () =>
        import(
          /* webpackChunkName: "questionnaire" */ "../views/Questionnaire.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/",
      name: "dashboard",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "dashboard" */ "../views/Dashboard.vue"),
    },
    {
      beforeEnter: AuthGuard,
      path: "/solutionsDatabase",
      name: "solutionsDatabase",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "solutionsDatabase" */ "../views/SolutionsDatabase.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/solutionsDatabase/:id",
      name: "solutionsDatabaseView",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "solutionsDatabaseView" */ "../views/SolutionsDatabase.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/solutionsDatabase/:id/action/:actionsCenter_id",
      name: "solutionsDatabaseActionView",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "solutionsDatabaseView" */ "../views/SolutionsDatabase.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/goals",
      name: "goals",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "goals" */ "../views/Goals.vue"),
    },
    {
      beforeEnter: AuthGuard,
      path: "/tabs",
      name: "tabs",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "tabs" */ "../views/Tabs.vue"),
    },
    {
      beforeEnter: AuthGuard,
      path: "/report",
      name: "report",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "report" */ "../views/Report.vue"),
    },
    {
      beforeEnter: AuthGuard,
      path: "/questions",
      name: "questions",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "questions" */ "../views/Questions.vue"),
    },
    {
      beforeEnter: AuthGuard,
      path: "/solutions",
      name: "solutions",
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "solutions" */ "../views/Admin/Management/Solutions.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/solutions/:id",
      name: "solutionsView",
      props: true,
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "solutions" */ "../views/Admin/Management/Solutions.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/solutions/:id/featuredListing/:featuredFindEntry_id",
      name: "solutionsViewFeaturedListingView",
      props: true,
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "solutions" */ "../views/Admin/Management/Solutions.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/solutions/:id/findEntries/:findEntriesID",
      name: "solutionsViewfindEntriesView",
      props: true,
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "solutions" */ "../views/Admin/Management/Solutions.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/solutions/:id/actions/:actionsID",
      name: "solutionsViewActionsView",
      props: true,
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "solutions" */ "../views/Admin/Management/Solutions.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/solutions/:id/articles/:articlesID",
      name: "solutionsViewArticlesView",
      props: true,
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "solutions" */ "../views/Admin/Management/Solutions.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/wizard",
      name: "wizard",
      meta: {
        offlineAvailability: false,
        fullscreen: true,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(/* webpackChunkName: "wizard" */ "../views/Wizard.vue"),
    },
    {
      beforeEnter: AuthGuard,
      path: "/users",
      name: "users",
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "users" */ "../views/Admin/Management/Users.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/myPlans",
      props: true,
      name: "myPlans",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "myPlans" */ "../views/MyPlans/myPlans.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/fullPlan/:id",
      props: true,
      name: "fullPlanView",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "fullPlanView" */ "../views/MyPlans/FullPlan.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/settings",
      props: true,
      name: "settings",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "settings" */ "../views/Settings/Settings.vue"
        ),
      children: [
        {
          beforeEnter: AuthGuard,
          path: "user",
          name: "userSettings",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "userSettings" */ "../views/Settings/UserSettings.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "organisation",
          name: "orgSettings",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "orgSettings" */ "../views/Settings/BusinessSettings.vue"
            ),
        },
      ],
    },
    {
      beforeEnter: AuthGuard,
      path: "/business",
      props: true,
      name: "business",
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "business" */ "../views/Admin/Business/Management.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/business/:business_id",
      props: true,
      name: "businessView",
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "businessView" */ "../views/Admin/Business/Management.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/myPlans/settings/:plan_id",
      props: true,
      name: "myPlansView",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "myPlansView" */ "../views/MyPlans/myPlans.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/outcome",
      props: true,
      name: "outcome",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "outcome" */ "../views/BusinessOutcomePlans/BusinessOutcomePlans.vue"
        ),
      children: [
        {
          beforeEnter: AuthGuard,
          path: ":outcomesID/dataUpload",
          name: "dataUpload",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "dataUpload" */ "../views/DataUpload.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: ":outcomesID/dataUpload/year/:year",
          name: "dataUpload",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "dataUpload" */ "../views/DataUpload.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: ":outcomesID/dataSummary/year/:year",
          name: "dataSummary",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "dataSummary" */ "../views/DataSummary.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: ":outcomesID/emissionCalculator/year/:year",
          name: "emissionCalculator",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "emissionCalculator" */ "../views/EmissionCalculator.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: ":outcomesID/emissionCalculator/year/:year/source/:sourceId",
          name: "emissionCalculatorCustomFactor",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "emissionCalculator" */ "../views/EmissionCalculator.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: ":outcomesID/goalSummary",
          name: "goalSummary",
          props: true,
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "goalSummary" */ "../views/GoalSummary.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: ":outcomesID/goalSummary/year/:year",
          name: "goalSummary",
          props: true,
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "goalSummary" */ "../views/GoalSummary.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: ":outcomesID/goalSummary/year/:year/source/:sourceID",
          name: "goalSummaryView",
          props: true,
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "goalSummary" */ "../views/GoalSummary.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: ":outcomesID/solutionWelder",
          name: "solutionWelder",
          props: true,
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "solutionWelder" */ "../views/SolutionWorkflow/solutionWelder.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: ":outcomesID/solutionSummary",
          name: "solutionSummary",
          props: true,
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "solutionSummary" */ "../views/SolutionWorkflow/solutionSummary.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: ":outcomesID/solutionSummary",
          name: "solutionSummary",
          props: true,
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "solutionSummary" */ "../views/SolutionWorkflow/solutionSummary.vue"
            ),
        },
      ],
    },
    {
      beforeEnter: AuthGuard,
      path: "/outcomePlans",
      props: true,
      name: "outcomePlans",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "outcomePlans" */ "../views/BusinessOutcomePlans/BusinessOutcomePlans.vue"
        ),
      children: [
        {
          beforeEnter: AuthGuard,
          path: "/",
          props: true,
          name: "outcomePlansSelection",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "outcomePlansSelection" */ "../views/BusinessOutcomePlans/OutcomePlansSelection.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID",
          props: true,
          name: "outcomePlansSelectionView",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "outcomePlansSelectionView" */ "../views/BusinessOutcomePlans/OutcomePlansSelection.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/chooseAssessmentTool",
          props: true,
          name: "outcomePlansSelectAssessmentTool",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "outcomePlansSelectAssessmentTool" */ "../views/BusinessOutcomePlans/ChooseAssessmentTool.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/chooseAssessmentTool/:selectedTool",
          props: true,
          name: "outcomePlansSelectAssessmentToolSelection",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "outcomePlansSelectAssessmentToolSelection" */ "../views/BusinessOutcomePlans/ChooseAssessmentTool.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/outcomePlanQuestionnaire",
          props: true,
          name: "outcomePlanQuestionnaireOutcomeQuestionView",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "outcomePlanQuestionnaireOutcomeQuestionView" */ "../views/OutcomePlanQuestionnaire.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/outcomePlanQuestionnaire/question/:outcomePlanQuestionnaire_id",
          props: true,
          name: "outcomePlanQuestionnaireOutcomeView",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "outcomePlanQuestionnaireOutcomeView" */ "../views/OutcomePlanQuestionnaire.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/outcomePlanQuestionnaire/question/completed",
          props: true,
          name: "outcomePlanQuestionnaireOutcomeViewComplete",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "outcomePlanQuestionnaireOutcomeViewComplete" */ "../views/OutcomePlanQuestionnaire.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/dataUpload/year/:year",
          name: "dataUpload",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "dataUpload" */ "../views/DataUpload.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/dataSummary/year/:year",
          name: "dataSummary",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "dataSummary" */ "../views/DataSummary.vue"
            ),
        },
        // {
        //   beforeEnter: AuthGuard,
        //   path: "outcome/:outcomesID/scale",
        //   name: "scaleQuestionnaire",
        //   meta: { offlineAvailability: false },
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "scaleQuestionnaire" */ "../views/ScaleQuestionnaire/scaleQuestionnaire.vue"
        //     ),
        // },
        // {
        //   beforeEnter: AuthGuard,
        //   path: "outcome/:outcomesID/scale/:scaleCategory_id",
        //   name: "scaleQuestionnaireView",
        //   meta: { offlineAvailability: false },
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "scaleQuestionnaireView" */ "../views/ScaleQuestionnaire/scaleQuestionnaire.vue"
        //     ),
        // },
        // {
        //   beforeEnter: AuthGuard,
        //   path: "outcome/:outcomesID/scaleSummary",
        //   name: "scaleQuestionnaireView",
        //   meta: { offlineAvailability: false },
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "scaleQuestionnaireView" */ "../views/ScaleQuestionnaire/scaleSummary.vue"
        //     ),
        // },

        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/storyBoard",
          name: "scaleQuestionnaire",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "scaleQuestionnaire" */ "../views/StoryBoard/storyBoard.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/storyBoard/:storyCard_id",
          name: "scaleQuestionnaireView",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "scaleQuestionnaireView" */ "../views/StoryBoard/storyBoard.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/storySummary",
          name: "storySummary",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "storySummary" */ "../views/StoryBoard/storySummary.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/storySummary/:storyCard_id",
          name: "storySummaryView",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "storySummary" */ "../views/StoryBoard/storySummary.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/emissionCalculator",
          name: "emissionCalculator",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "emissionCalculator" */ "../views/EmissionCalculator.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/emissionCalculator/year/:year",
          name: "emissionCalculator",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "emissionCalculator" */ "../views/EmissionCalculator.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/emissionCalculator/year/:year/source/:sourceId",
          name: "emissionCalculatorCustomFactor",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "emissionCalculatorCustomFactor" */ "../views/EmissionCalculator.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/goalSummary",
          name: "goalSummary",
          props: true,
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "goalSummary" */ "../views/GoalSummary.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/goalSummary/year/:year",
          name: "goalSummary",
          props: true,
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "goalSummary" */ "../views/GoalSummary.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/goalSummary/year/:year/source/:sourceID",
          name: "goalSummaryView",
          props: true,
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "goalSummaryView" */ "../views/GoalSummary.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/solutionWelder",
          name: "solutionWelder",
          props: true,
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "solutionWelder" */ "../views/SolutionWorkflow/solutionWelder.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/solutionWelder/solutionsDatabase",
          name: "solutionWelderSolutionsDatabase",
          props: true,
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "solutionWelderSolutionsDatabase" */ "../views/SolutionsDatabase.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/solutionWelder/solutionsDatabase/:id",
          name: "solutionWelderSolutionsDatabase",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "solutionWelderSolutionsDatabaseView" */ "../views/SolutionsDatabase.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/solutionWelder/solutionsDatabase/:id/action/:actionsCenter_id",
          name: "solutionWelderSolutionsDatabase",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "solutionWelderSolutionsDatabaseView" */ "../views/SolutionsDatabase.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "outcome/:outcomesID/solutionSummary",
          name: "solutionSummary",
          props: true,
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "solutionSummary" */ "../views/SolutionWorkflow/solutionSummary.vue"
            ),
        },
      ],
    },
    {
      beforeEnter: AuthGuard,
      path: "/reports",
      props: true,
      name: "reports",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "reports" */ "../views/Reporting/ReportView.vue"
        ),
      children: [
        {
          beforeEnter: AuthGuard,
          path: "data",
          props: true,
          name: "dataReporting",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "dataReporting" */ "../views/Reporting/DataReporting.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "data/outcome/:outcomeID",
          props: true,
          name: "dataReportingOutcome",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "dataReportingOutcome" */ "../views/Reporting/DataReporting.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "data/outcome/:outcomeID/year/:year",
          props: true,
          name: "dataReportingOutcome",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "dataReportingOutcome" */ "../views/Reporting/DataReporting.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "data/outcome/:outcomeID/year/:year/category/:categoryID",
          props: true,
          name: "dataReportingCategory",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "dataReportingCategory" */ "../views/Reporting/DataReporting.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "data/outcome/:outcomeID/year/:year/category/:categoryID/source/:sourceID",
          props: true,
          name: "dataReportingSource",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "dataReportingSource" */ "../views/Reporting/DataReporting.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "storyBoard",
          props: true,
          name: "storyBoardView",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "storyBoardView" */ "../views/Reporting/StoryBoard.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "storyBoard/outcome/:outcomeID",
          props: true,
          name: "storyBoardView",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "storyBoardView" */ "../views/Reporting/StoryBoard.vue"
            ),
        },
        {
          beforeEnter: AuthGuard,
          path: "storyBoard/outcome/:outcomeID/year/:year",
          props: true,
          name: "storyBoardView",
          meta: { offlineAvailability: false },
          component: () =>
            import(
              /* webpackChunkName: "storyBoardView" */ "../views/Reporting/StoryBoard.vue"
            ),
        },
        // {
        //   beforeEnter: AuthGuard,
        //   path: "scaleReporting",
        //   props: true,
        //   name: "scaleReportingView",
        //   meta: { offlineAvailability: false },
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "scaleReportingView" */ "../views/Reporting/ScaleReporting.vue"
        //     ),
        // },
        // {
        //   beforeEnter: AuthGuard,
        //   path: "scaleReporting/outcome/:outcomeID",
        //   props: true,
        //   name: "scaleReportingView",
        //   meta: { offlineAvailability: false },
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "scaleReportingView" */ "../views/Reporting/ScaleReporting.vue"
        //     ),
        // },
        // {
        //   beforeEnter: AuthGuard,
        //   path: "scaleReporting/outcome/:outcomeID/year/:year",
        //   props: true,
        //   name: "scaleReportingView",
        //   meta: { offlineAvailability: false },
        //   component: () =>
        //     import(
        //       /* webpackChunkName: "scaleReportingView" */ "../views/Reporting/ScaleReporting.vue"
        //     ),
        // },
      ],
    },
    {
      beforeEnter: AuthGuard,
      path: "/outcomes",
      name: "outcomes",
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "outcomes" */ "../views/Admin/System/Outcomes.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/outcomes/:id",
      props: true,
      name: "outcomesView",
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "outcomesView" */ "../views/Admin/System/Outcomes.vue"
        ),
    },

    {
      beforeEnter: AuthGuard,
      path: "/outcomes/:id/questions/:outcomePlanQuestionnaire_id",
      props: true,
      name: "outcomesQuestionsView",
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "outcomesQuestionsView" */ "../views/Admin/System/Outcomes.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/outcomes/:id/questions/:outcomePlanQuestionnaire_id/options/:outcomePlanQuestionnaireOptions_id",
      props: true,
      name: "outcomesQuestionsViewOptionsView",
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "outcomesQuestionsViewOptionsView" */ "../views/Admin/System/Outcomes.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/sources",
      name: "sources",
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "sources" */ "../views/Admin/Management/Sources.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/sources/:id",
      name: "sourcesView",
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      props: true,
      component: () =>
        import(
          /* webpackChunkName: "sourcesView" */ "../views/Admin/Management/Sources.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/sources/:id/:referenceID",
      name: "sourcesViewReferenceView",
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      props: true,
      component: () =>
        import(
          /* webpackChunkName: "sourcesViewReferenceView" */ "../views/Admin/Management/Sources.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/preWrittenGoals",
      name: "preWrittenGoals",
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "preWrittenGoals" */ "../views/Admin/Management/BasicGoals.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/preWrittenGoals/:basicGoal_id",
      name: "preWrittenGoalsView",
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      props: true,
      component: () =>
        import(
          /* webpackChunkName: "preWrittenGoalsView" */ "../views/Admin/Management/BasicGoals.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/dataSummary/:outcomeId",
      name: "dataSummary",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "dataSummary" */ "../views/DataSummary.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/dataSummary/:outcomeId/year/:year",
      name: "dataSummary",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "dataSummary" */ "../views/DataSummary.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/emissionCalculator/:outcomeId",
      name: "emissionCalculator",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "emissionCalculator" */ "../views/EmissionCalculator.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/emissionCalculator/:outcomeId/year/:year",
      name: "emissionCalculator",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "emissionCalculator" */ "../views/EmissionCalculator.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/emissionCalculator/:outcomeId/year/:year/source/:sourceId",
      name: "emissionCalculatorCustomFactor",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "emissionCalculatorCustomFactor" */ "../views/EmissionCalculator.vue"
        ),
    },

    {
      beforeEnter: AuthGuard,
      path: "/dataUpload",
      name: "dataUpload",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "dataUpload" */ "../views/DataUpload.vue"),
    },
    {
      beforeEnter: AuthGuard,
      path: "/actionCentre",
      name: "actionCentre",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "actionCentre" */ "../views/ActionCentre.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/workspaceDashboard",
      name: "workspaceDashboard",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "workspaceDashboard" */ "../views/WorkspaceDashboard.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/workspace/:outcomesID",
      name: "workspace",
      props: true,
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "workspace" */ "../views/Workspace.vue"),
    },
    {
      beforeEnter: AuthGuard,
      path: "/workspace/:outcomesID/goal/:goalID",
      name: "workspaceGoalView",
      props: true,
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "workspaceGoalView" */ "../views/Workspace.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/units",
      name: "units",
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "units" */ "../views/Admin/Management/Units.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/units/:id",
      name: "unitsView",
      props: true,
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "unitsView" */ "../views/Admin/Management/Units.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/pageHelp",
      name: "pageHelp",
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "pageHelp" */ "../views/Admin/System/PageHelp.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/pageHelp/:pageHelp_id",
      name: "pageHelpView",
      props: true,
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "pageHelpView" */ "../views/Admin/System/PageHelp.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/actionTemplates",
      name: "actionTemplates",
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "actionTemplates" */ "../views/Admin/System/ActionTemplates.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/actionTemplates/:actionTemplates_id",
      name: "actionTemplatesView",
      props: true,
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "actionTemplatesView" */ "../views/Admin/System/ActionTemplates.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/researchAndInsights",
      name: "researchAndInsights",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "researchAndInsights" */ "../views/ResearchAndInsights.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/researchAndInsightsView",
      name: "researchAndInsightsView",
      props: true,
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "researchAndInsightsView" */ "../views/ResearchAndInsightsView.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/researchAndInsightsView/:id",
      name: "researchAndInsightsViewID",
      props: true,
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "researchAndInsightsViewID" */ "../views/ResearchAndInsightsView.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/researchAndInsightsView/:id/article/:articleID",
      name: "researchAndInsightsViewArticle",
      props: true,
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "researchAndInsightsViewArticle" */ "../views/ResearchAndInsightsView.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/articles",
      name: "articles",
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "articles" */ "../views/Admin/Management/Articles.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/articles/:id",
      name: "articlesView",
      props: true,
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "articlesView" */ "../views/Admin/Management/Articles.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/articles/:id/:previewID",
      name: "articlesViewPreview",
      props: true,
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "articlesViewPreview" */ "../views/Admin/Management/Articles.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/articlesKeywords",
      name: "articlesKeywords",
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "articlesKeywords" */ "../views/Admin/Management/ArticlesKeywords.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/articlesKeywords/:id",
      name: "articlesKeywordsView",
      props: true,
      meta: {
        offlineAvailability: false,
        roles: {
          Admin: true,
        },
      },
      component: () =>
        import(
          /* webpackChunkName: "articlesKeywordsView" */ "../views/Admin/Management/ArticlesKeywords.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/outcomeSelection",
      name: "outcomeSelection",
      props: true,
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "outcomeSelection" */ "../views/OutcomeSelection.vue"
        ),
    },
    // {
    //   beforeEnter: AuthGuard,
    //   path: "/goalSummary/:outcomesID",
    //   name: "goalSummary",
    //   props: true,
    //   meta: { offlineAvailability: false },
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "goalSummary" */ "../views/GoalSummary.vue"
    //     ),
    // },
    // {
    //   beforeEnter: AuthGuard,
    //   path: "/goalSummary/:outcomesID/:sourceID",
    //   name: "goalSummaryView",
    //   props: true,
    //   meta: { offlineAvailability: false },
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "goalSummaryView" */ "../views/GoalSummary.vue"
    //     ),
    // },
    {
      beforeEnter: AuthGuard,
      path: "/outcomePlanQuestionnaire/outcome/:outcomesID",
      props: true,
      name: "outcomePlanQuestionnaireOutcomeQuestionView",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "outcomePlanQuestionnaireOutcomeQuestionView" */ "../views/OutcomePlanQuestionnaire.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/outcomePlanQuestionnaire/outcome/:outcomesID/question/:outcomePlanQuestionnaire_id",
      props: true,
      name: "outcomePlanQuestionnaireOutcomeView",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "outcomePlanQuestionnaireOutcomeView" */ "../views/OutcomePlanQuestionnaire.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/outcomePlanQuestionnaire/outcome/:outcomesID/question/completed",
      props: true,
      name: "outcomePlanQuestionnaireOutcomeViewComplete",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "outcomePlanQuestionnaireOutcomeViewComplete" */ "../views/OutcomePlanQuestionnaire.vue"
        ),
    },
    {
      beforeEnter: AuthGuard,
      path: "/solutionsGoalsSummary/:outcomesID",
      props: true,
      name: "solutionsGoalsSummary",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "solutionsGoalsSummary" */ "../views/SolutionsGoalsSummary.vue"
        ),
    },

    {
      beforeEnter: AuthGuard,
      path: "/solutionsGoalsSummary/:outcomesID/goals/:goalsID",
      props: true,
      name: "solutionsGoalsSummary",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "solutionsGoalsSummary" */ "../views/SolutionsGoalsSummary.vue"
        ),
    },

    {
      beforeEnter: AuthGuard,
      path: "/userPlan/:outcomesID",
      props: true,
      name: "UserPlan",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "UserPlan" */ "../views/UserPlan.vue"),
    },
  ],
});
